{
  "cms.catalogRow.action.duplicateUnit": "Duplicate",
  "cms.duplicate.titleMarker": "{title} (copy)",
  "cms.duplicate.done": "Copy created in drafts.",
  "cms.duplicate.error.titleTaken": "The copy was not created: the name \"{title}\" is already in use. Rename the earlier copy.",
  "cms.duplicate.error.incompleteUnit": "This row cannot be duplicated: it is not a complete publication unit.",
  "cms.duplicate.error": "Duplicating failed. Please try again."
}
